/**
 * @generated SignedSource<<12e07eeddaeaf928ae695bd82fc5e9f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserSocialProfileLinks_user$data = {
  readonly blueskyUrl: string | null | undefined;
  readonly githubUrl: string | null | undefined;
  readonly instagramUrl: string | null | undefined;
  readonly linkedinUrl: string | null | undefined;
  readonly twitterUrl: string | null | undefined;
  readonly websiteUrl: string | null | undefined;
  readonly youtubeUrl: string | null | undefined;
  readonly " $fragmentType": "UserSocialProfileLinks_user";
};
export type UserSocialProfileLinks_user$key = {
  readonly " $data"?: UserSocialProfileLinks_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserSocialProfileLinks_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserSocialProfileLinks_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "websiteUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "twitterUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instagramUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkedinUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "youtubeUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "githubUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blueskyUrl",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f459398d0912f72444af16c6f6797cdc";

export default node;
